import { render, staticRenderFns } from "./Rolls.vue?vue&type=template&id=759aed95&"
import script from "./Rolls.vue?vue&type=script&lang=js&"
export * from "./Rolls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports